import currencyFormatter from 'currency-formatter';
import React from 'react';
import { currencyService } from 'services/CurrencyService';
import { useObservable } from 'react-use-observable';

interface IProps {
  value: number;
}

export const CurrencyFormat: React.FC<IProps> = React.memo(({ value }) => {
  const [currency] = useObservable(() => currencyService.getCurrency(), []);

  if (!currency) {
    return null;
  }

  const formatedValue = currencyFormatter.format(value, { code: currency, precision: 2 });

  return <span>{formatedValue}</span>;
});
